import React from "react"
import { useHookstate } from "@hookstate/core"
import { useConfigDataState } from "../../globalStates/ConfigDataState"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import Page from "../../components/Page"
import MultimediaContents from "./MultimediaContents"

const MultimediaPage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const mediaStates = useHookstate(useExhibitorDataState().getMedias())
    const serviceKeys = useConfigDataState().getServiceKeys()

    return (
        <Page description={branding.configuration.multimediaPage.pageDescription}>
            <MultimediaContents mediaStates={mediaStates} multimediaLimit={serviceKeys.multimedia || 0} />
        </Page>
    )
}

export default MultimediaPage
